var React = require('react');

function OpenSidebar (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#262627","fillRule":"evenodd"},[React.createElement("circle",{"cx":"2","cy":"2","r":"2","key":0}),React.createElement("circle",{"cx":"10","cy":"2","r":"2","key":1}),React.createElement("circle",{"cx":"18","cy":"2","r":"2","key":2})]));
}

OpenSidebar.defaultProps = {"width":"20","height":"4","viewBox":"0 0 20 4"};

module.exports = OpenSidebar;

OpenSidebar.default = OpenSidebar;
